import React from 'react'
import _ from 'underscore'
import LeadHeader from './header'
import ClaimLeadButton from './buttons/claim'
import LeadDetails from './tabs/details/show'
import LeadActivity from './tabs/activity/show'

class Lead extends React.Component {

  constructor(props) {
    super(props)
    
    this.state = {
      left_tab: 'notes'
    }
  }

  onLeftTabClick = (value) => {
    this.setState({left_tab: value})
  }

  render() {
    return (
      <div>
        {this.props.lead.actions.can_claim ?
          <div className="bg-muted">
            <ClaimLeadButton
              lead_id={this.props.lead.id}
              sales_manager={this.props.lead.manager}
              store={this.props.store}
            />
          </div>
          : null
        }
        <div className="flex flex-col gap-4 bg-slate-400 p-6">
          <LeadHeader
            lead={this.props.lead}
            ui={this.props.ui}
          />
        </div>
        <div className="grid flex-1 grid-cols-1 items-start gap-4 bg-muted p-4 md:grid-cols-2">
          {(this.state.left_tab === 'notes') ?
            <LeadActivity
              lead={this.props.lead}
            />
            : null
          }
          <LeadDetails
            lead={this.props.lead}
            ui={this.props.ui}
            store={this.props.store}
          />
        </div>
      </div>
    )
  }
}

export default Lead
